<template>
	<div class="internet-hmi">
		<div class="box-1">
			<img src="../../assets/imgs/MA-HMI-11.png" alt="" />
			<div>
				<h3>{{ $t("HMI.title") }}</h3>
				<p>
					{{ $t("HMI.HMILabel") }}
				</p>
				<ul class="box-1-list">
					<li v-for="(item, index) in hmiList" :key="index">
						<img :src="item.url" />
						<span>{{ item.label }}</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="box-1">
			<div>
				<h3>{{ $t("HMI.Clearness") }}</h3>
				<p>
					{{ $t("HMI.IIoT") }}
				</p>
				<div
					class="box-1-list2"
					v-for="(item, index) in hmiList2"
					:key="index"
				>
					<img :src="item.url" />
					<div>{{ item.resolve }}</div>
					<div>{{ item.edg }}</div>
					<div>{{ item.measure }}</div>
				</div>
			</div>
			<img src="../../assets/imgs/MA-HMI-2.png" alt="" />
		</div>
		<div class="box-1">
			<img src="../../assets/imgs/MA-HMI-3.png" alt="" />
			<div>
				<h3>{{ $t("HMI.modules") }}</h3>
				<p>
					{{ $t("HMI.dedicated") }}
				</p>
				<div>
					<img src="../../assets/imgs/MA-HMI-list-7.png" alt="" />
				</div>
			</div>
		</div>
		<div class="box-1">
			<div>
				<h3>{{ $t("HMI.Flexible") }}</h3>
				<p>
					{{ $t("HMI.choose") }}
				</p>
			</div>
			<img src="../../assets/imgs/MA-HMI-4.png" alt="" />
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			hmiList: [
				{
					url: require("../../assets/imgs/MA-HMI-list-1.png"),
					label: this.$t("HMI.interaction"),
				},
				{
					url: require("../../assets/imgs/MA-HMI-list-2.png"),
					label: this.$t("HMI.Internet"),
				},
				{
					url: require("../../assets/imgs/MA-HMI-list-3.png"),
					label: this.$t("HMI.Analysis"),
				},
				{
					url: require("../../assets/imgs/MA-HMI-list-4.png"),
					label: this.$t("HMI.Remote"),
				},
			],
			hmiList2: [
				{
					url: require("../../assets/imgs/MA-HMI-list-5.png"),
					resolve: "1024*600",
					edg: "170°",
					measure: "450cd/m²",
				},
				{
					url: require("../../assets/imgs/MA-HMI-list-6.png"),
					resolve: "1024*600",
					edg: "170°",
					measure: "450cd/m²",
				},
			],
		};
	},
};
</script>
<style lang="scss">
.internet-hmi {
	.box-1 {
		display: flex;
		justify-content: center;
		margin: 120px 0;
		align-items: center;
		> div {
			width: 600px;
			display: flex;
			flex-direction: column;
			padding: 0 40px;
			p {
				font-size: 16px;
				line-height: 30px;
				color: #666666;
				margin-bottom: 40px;
			}
			.box-1-list {
				display: flex;
				flex: 1;
				li {
					flex: 1;
				}
			}
			.box-1-list2 {
				display: flex;
				justify-content: space-between;
				align-content: center;
				line-height: 55px;
				width: 515px;
				color: #666666;
				font-size: 30px;
				margin-bottom: 40px;
				flex-direction: row;
			}
		}
	}
	.box-2 {
		text-align: center;
		p {
			margin-bottom: 50px;
		}
	}
	h3 {
		font-size: 48px;
		text-align: center;
		font-weight: inherit;
		margin-bottom: 38px;
	}
}
</style>
